import { usePage } from "@inertiajs/react";

import BookReview from "components/BookReview/BookReview";
import BookOwnerReviewNotice from "features/books/components/BookOwnerReviewNotice";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";
import Container from "hardcover-ui/components/Container";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";

import { BookReviewsShowProps } from "./show.props";

function ReviewsShow() {
  const { book, review } = usePage<BookReviewsShowProps>().props;
  const currentUserId = useCurrentUserId();

  return (
    <BookLayout>
      <Container variant="layout" size="md">
        {review.userId === currentUserId ? (
          <BookOwnerReviewNotice book={book} userBook={review} />
        ) : (
          false
        )}
        <BookReview
          book={book}
          userBook={review}
          linkToReview={false}
          expanded
          allowCollapse={false}
        />
      </Container>
    </BookLayout>
  );
}

ReviewsShow.layout = DefaultLayoutWrapper;
export default ReviewsShow;
